import { Translation } from "@/data/lang";

import type { ToggleButtonOption } from "ui/widget/toggle-buttons";

import { HoldingsInfoCategory } from "../services/get-investor-holdings-info";

export const getHoldingsInfoOptions = ({
  t,
}: {
  t: Translation;
}): ToggleButtonOption[] => [
  { value: t.my13F.investor.all },
  { value: t.my13F.investor.openPosition },
  { value: t.my13F.investor.overweight },
  { value: t.my13F.investor.flat },
  { value: t.my13F.investor.underweight },
  { value: t.my13F.investor.closePosition },
];

export const HoldingsInfoList: HoldingsInfoCategory[] = [
  "all",
  "open-position",
  "overweight",
  "flat",
  "underweight",
  "close-position",
];
